import { API_BASE, buildQuery, request } from './api-client';
import type { AdminPaymentRow, Paginated, RefundInitiatedResponse } from '../types';

export function listUserPayments(
  userId: string,
  query: { page?: number; limit?: number; status?: string; gateway?: string; refundedOnly?: boolean },
) {
  return request<Paginated<AdminPaymentRow>>(
    `${API_BASE}/admin/users-mgmt/${userId}/payments${buildQuery(query as Record<string, unknown>)}`,
  );
}

export function confirmPurchaseFault(invoiceId: string, reason: string) {
  return request<{ purchaseId: string; flaggedAt: string }>(`${API_BASE}/admin/payments/${invoiceId}/confirm-fault`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}

// `Idempotency-Key` is required by the backend (06_PAYMENT_DOMAIN_IDEMPOTENCY_FINANCIAL_SAFETY.md
// §5) — never omit it. The refund is initiated, not yet confirmed; the
// caller should treat the response as "pending" and rely on a refetch of
// listUserPayments (refundPending/refundedAt) for the confirmed state.
export function refundPayment(
  input: { paymentId: string; amount?: number; reason: string; category: 'SERVICE_FAULT' | 'PAYMENT_ISSUE' | 'PACK_REFUND'; overrideWindowReason?: string; overrideSuggestion?: boolean },
  idempotencyKey: string,
) {
  return request<RefundInitiatedResponse>(`${API_BASE}/admin/payments/refund`, {
    method: 'POST',
    headers: { 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(input),
  });
}
